import { RenderConfig } from "@/(admin)/modules/ui-builder/config/themes/tamda-one/FAQs/RenderConfig"
import { t } from "@/languages/i18n"
import CKEditorWrapper from "@/lib/config/lib/CkeditorWrapper"
import { FAQsProps } from "@/types/types"
import { ComponentConfig } from "@measured/puck"

export const FAQs: ComponentConfig<FAQsProps> = {
  label: "Tamda Group | FAQs",
  fields: {
    // Bỏ titleCategory và category vì không dùng nữa
    faqs: {
      label: "Danh sách FAQs",
      type: "array",
      arrayFields: {
        question: {
          label: "Câu hỏi",
          type: "text",
        },
        answer: {
          label: "Câu trả lời",
          type: "custom",
          render: ({ value, onChange }) => {
            return <CKEditorWrapper value={value} onChange={onChange} />
          },
        },
      },
    },
    className: {
      label: "Class Name (tuỳ chỉnh thêm)",
      type: "text",
    },
  },
  defaultProps: {
    faqs: [
      {
        question: t("Where can I buy Tamda Foods products?"),
        answer: t(
          "You can shop at Tamda Foods branches in Praha, Brno, Ústí nad Labem, or online with home delivery via tamdaexpress.eu. We're always ready to serve you!",
        ),
      },
      {
        question: t("Can I shop without a customer card?"),
        answer: t("Absolutely! You can shop without a card, but the prices may differ from those for cardholders."),
      },
    ],
    className: "",
  },
  ...RenderConfig,
}
